export default "__VITE_ASSET__tVBtzMz$__"